import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { MasterFormComponent } from '../../form/master-form/master-form.component';

@Component({
  selector: 'app-master-page',
  templateUrl: './master-page.component.html',
  styles: []
})
export class MasterPageComponent extends MasterFormComponent {

  @Output() added = new EventEmitter()

  @ViewChild('modal') modal: any
  @ViewChild('form') formComponent: any

  list = []


  add(data){

    return this.formComponent.insert().then(data => {
      this.ngOnInit()
      this.added.emit(data)
      return data
    }).catch(ex => {

      this.$app.alert.warning(ex.message)
    })
  }

  edit(id){

    return this.formComponent.update(id).then(data => {
      this.ngOnInit()
      return data
    }).catch(ex => {

      this.$app.alert.warning(ex.message)
    })
  }

  delete(id){

    return this.formComponent.delete(id).then(data => {
      this.ngOnInit()
      return data
    }).catch(ex => {

      this.$app.alert.warning(ex.message)
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/components/page/master-page/master-page.component.ts